app.service("NHISearchPatientsAPI", [
	"$http",
	"ENV",
	"Session",
	function ($http, ENV, Session) {
		var service = {
			isProcessing: false,

			searchAllNHIPatients: function (nhi) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/nhi/${encodeURIComponent(nhi)}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			queryPatients: function (lastName, DOB) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/nhi?lastName=${encodeURIComponent(lastName)}&dob=${encodeURIComponent(DOB)}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			searchAllNHIPatientsV2: function (nhi) {
				return $http({
					method: "GET",
					url: ENV.API + `/api/nhi/${encodeURIComponent(nhi)}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},
			queryPatientsV2: function(lastName, dob,firstName='', middleName='') {
				let option = '';
				if(firstName){
					option = option +  `&firstName=${encodeURIComponent(firstName)}`
				}
				if(middleName){
					option = option +  `&middleName=${encodeURIComponent(middleName)}`
				}
				return $http({
					method: 'GET',
					url: ENV.API + `/api/nhi?dob=${encodeURIComponent(dob)}&lastName=${encodeURIComponent(lastName)}${option}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"Content-Type": "application/json",
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			queryPractitioners: function (fullName) {
				return $http({
					method: 'GET',
					url: ENV.API + `/api/hpi/practitioner?searchTerm=${encodeURIComponent(fullName || "")}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			queryOrganisations: function (name) {
				return $http({
					method: 'GET',
					url: ENV.API + `/api/hpi/organisation?searchTerm=${encodeURIComponent(name || "")}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			queryLocations: function (name) {
				return $http({
					method: 'GET',
					url: ENV.API + `/api/hpi/location?searchTerm=${encodeURIComponent(name || "")}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			queryLocationsByOrg: function (hpiOrganisationId) {
				return $http({
					method: 'GET',
					url: ENV.API + `/api/hpi/location?hpiOrganisationId=${encodeURIComponent(hpiOrganisationId)}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			queryLocationsByTermsAndPharmacy: function (searchTerm) {
				return $http({
					method: 'GET',
					url: ENV.API + `/api/hpi/location/pharmacy?searchTerm=${encodeURIComponent(searchTerm || "")}`,
					headers: {
						'Authorization': 'Bearer ' + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					}
				})
			},
			transformGenderProp: function (gender) {
				if(gender === 'MALE' || gender === 'FEMALE'){
					return gender.toUpperCase();
				}
				return 'OTHER';
			},
			// The NHI service doesn't always flag a name as preferred, and a record can come back with no
			// names at all - fall back to the first name, then to blanks, rather than throwing.
			getPreferredName: function (names) {
				names = names || [];
				const preferred = names.find((t) => t && t.preferred) || names[0] || {};
				const givenNames = preferred.givenNameList || [];
				return {
					firstNameCol: givenNames[0] || '',
					middleNameCol: givenNames[1] || '',
					familyNameCol: preferred.familyName || '',
				};
			}
		};

		return service;
	},
]);
